import palette from '../palette';

export default {
  root: {},
  label: {
    color: palette.black,
  },
};
